@if (swSettingsOpened) {
    <app-settings (closed)="swSettingsOpened = !swSettingsOpened"></app-settings>
}
<div class="custom-toolbar">
    <button
        kendoButton
        data-testid="archive-toggle-menu-button"
        fillMode="flat"
        aria-label="Toggle menu"
        icon="menu"
        [disabled]="router.url === ROUTE_REORDERING"
        (click)="toggleDrawer()"
    ></button>
    <kendo-menu
        class="custom-menu"
        [animate]="animationSettings"
        [items]="menuItems"
        [popupSettings]="popupSettings"
        (select)="onMenuSelect($event)"
    ></kendo-menu>
    <span class="mode-box">{{ this.mode }}</span>
    <button
        kendoButton
        data-testid="archive-toggle-settings-button"
        fillMode="flat"
        aria-label="Settings"
        icon="optimization"
        (click)="swSettingsOpened = !swSettingsOpened"
    ></button>
</div>
